import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

interface CheckoutPresentation {
  inline: boolean;
  successUrl?: string;
  isActive?: () => boolean;
}

const CheckoutPresentationContext = createContext<CheckoutPresentation>({ inline: false });
export const CheckoutPresentationProvider = CheckoutPresentationContext.Provider;

export function useCheckoutPresentation(): CheckoutPresentation {
  return useContext(CheckoutPresentationContext);
}
